module.exports = __webpack_public_path__ + "static/img/05bg.c572eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/05bg.png
// module id = R/iQ
// module chunks = 1